package tta.destinigo.talktoastro.feature_expert_search.data

enum class SearchDisplay {
    InitialResults, Suggestions, Results, NoResults
}